import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import DonutChart from "@/components/ui/pie-chart";
import { numTrialDays, toCapital } from "@/utils/utils";
import { Check } from "lucide-react";
import { RecurringStatusState, type SubscriptionInformationCardProps } from "../musio-plus";
import useMusioApi from "@/contexts/client/musio-client-context";
import { NotificationRow } from "@/components/ui/notification-row";
import { Button } from "@/components/ui/button";
import { LoadingIndicator } from "@/components/ui/loading-indicator";

export const CancelledCard: React.FC<SubscriptionInformationCardProps> = ({ recurringStatus }) => {
  const trialing = recurringStatus.status == RecurringStatusState.Trialing;
  const numberTrialDays = numTrialDays(recurringStatus.periodEnd);
  const { musioApi } = useMusioApi();

  const { mutate, isPending, isError: isReactivateError } = musioApi.useMutation("post", "/user/recurring", {
    onSuccess: () => window.location.reload(),
  });

  return (
    <Card className="relative max-w-[373px] w-full flex flex-col space-y-8 justify-between bg-musio-bg p-4">
      <Check className="absolute top-5 right-2 h-3 w-3 font-extrabold text-black bg-musio-green rounded-full" />
      <CardHeader className="p-0">
        <CardTitle className="flex flex-col items-center align-middle justify-center">
          <p className="text-xl font-semibold text-center text-musio-orange">Canceled</p>
          <p className="text-center font-semibold text-lg text-lilac">{toCapital(recurringStatus.plan!)}</p>
          <p className="text-center font-normal text-[10px] text-musio-orange">Ends {recurringStatus.periodEnd}</p>
        </CardTitle>
      </CardHeader>

      {trialing &&
        <CardContent className="flex flex-row items-center justify-center p-0 gap-x-2">
          <p className="text-sm font-normal text-musio-orange">{numberTrialDays} days left in trial</p>
          <DonutChart daysLeft={numberTrialDays} totalDays={31} width={18} height={18} />
        </CardContent>
      }

      <CardFooter className="flex flex-col gap-0.5 p-0">
        {isPending ? (
          <LoadingIndicator />
        ) : (
          <div className="flex flex-col space-y-2">
            {isReactivateError ? (
              <NotificationRow intent="error">
                {isReactivateError}
              </NotificationRow>
            ) : null}
            <Button
              className="w-full bg-musio-blue text-musio-light-lilac hover:text-musio-toggle"
              onClick={() => mutate({
                body: {
                  canceled: false,
                }
              })}
            >
              Reactivate
            </Button>
          </div>
        )}
      </CardFooter>
    </Card>
  );
};
